import { render, staticRenderFns } from "./LoginRoleFormGroup.vue?vue&type=template&id=3ead738f&"
import script from "./LoginRoleFormGroup.vue?vue&type=script&lang=js&"
export * from "./LoginRoleFormGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/locales/login.locale.json?vue&type=custom&index=0&blockType=i18n&issuerPath=E%3A%5Capp%5CJenkins%5Cworkspace%5CBD%20ESH%20300%20Nextore%20V3%20BD%20Client%5Csrc%5Csrc%5Cforms%5Clogin%5CLoginRoleFormGroup.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports